export const ROLES:{[key:string]:number} = {
  god: 1000,
  demigod:100,
  minion: 10,
  observer: 1
};
